import './_latest-events-styles.scss';
import './latest-events';
